var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1450_13101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400391,
    y: 0.398438,
    width: 19.2,
    height: 19.2,
    rx: 3,
    fill: "#5948FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.296 6.41861L8.81176 14.6839C8.74548 14.7577 8.65524 14.7992 8.56111 14.7992C8.46698 14.7992 8.37675 14.7577 8.31046 14.6839L4.50482 10.4811C4.43798 10.4079 4.40039 10.3082 4.40039 10.2043C4.40039 10.1003 4.43798 10.0007 4.50482 9.92746L4.99906 9.38164C5.06534 9.30783 5.15558 9.26631 5.24971 9.26631C5.34384 9.26631 5.43407 9.30783 5.50036 9.38164L8.55758 12.7579L15.3004 5.31138C15.4401 5.16183 15.6621 5.16183 15.8017 5.31138L16.296 5.86499C16.3628 5.9382 16.4004 6.03785 16.4004 6.1418C16.4004 6.24576 16.3628 6.34541 16.296 6.41861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.296 6.41861L8.81176 14.6839C8.74548 14.7577 8.65524 14.7992 8.56111 14.7992C8.46698 14.7992 8.37675 14.7577 8.31046 14.6839L4.50482 10.4811C4.43798 10.4079 4.40039 10.3082 4.40039 10.2043C4.40039 10.1003 4.43798 10.0007 4.50482 9.92746L4.99906 9.38164C5.06534 9.30783 5.15558 9.26631 5.24971 9.26631C5.34384 9.26631 5.43407 9.30783 5.50036 9.38164L8.55758 12.7579L15.3004 5.31138C15.4401 5.16183 15.6621 5.16183 15.8017 5.31138L16.296 5.86499C16.3628 5.9382 16.4004 6.03785 16.4004 6.1418C16.4004 6.24576 16.3628 6.34541 16.296 6.41861Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1450_13101"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400391,
    y: 0.398438,
    width: 19.2,
    height: 19.2,
    rx: 3,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxArrowIcon);
export default __webpack_public_path__ + "static/media/checkbox-arrow-icon.32f424a5e0ef99bcc9bf045b4b272447.svg";
export { ForwardRef as ReactComponent };